/**
 * Art safe zones for Aloha layout themes.
 *
 * Each entry maps a themeId to the space that must be reserved at the top and
 * bottom of the WelcomeCard so content does not overlap the theme's decorative
 * art/sprites.
 *
 * IMPORTANT — why values are `vw` (viewport-width) units, not `vh`:
 * The art sprites are positioned by the (external) StyleApplicator as
 * `position: absolute; top: <px>; width: <%>; height: auto`. Because height is
 * `auto`, the art's rendered height is driven by its WIDTH (width% × aspect
 * ratio), NOT by viewport height. So the space the art occupies scales with the
 * viewport WIDTH. Expressing the reserve in `vw` keeps it in sync with the art
 * at any viewport size; `vh` would diverge on short/wide viewports (shrinking
 * the reserve while the width-driven art grows), which is the overlap bug.
 *
 * Values are `vw` units (i.e. % of viewport width). They are:
 *  - subtracted from `100vh` to bound the content area height
 *    (`calc(100vh - top vw - bottom vw)`), and
 *  - applied as top/bottom padding to position content within the safe band.
 * Content taller than the band is uniformly scaled down to fit (FitContentToHeight).
 *
 * Only themes that have been measured need entries here — themes without an
 * entry fall back to default (unconstrained) behavior.
 *
 * To add/tune a theme:
 * 1. Open a guest site using that theme at a small desktop viewport (1280×650)
 * 2. Measure the art's lowest top-sprite edge and highest bottom-sprite edge
 * 3. Express each as a % of the viewport WIDTH and add an entry below
 */
type ArtSafeZone = Readonly<{
  /** Space to reserve at the top for art, in `vw` (% of viewport width). */
  top: number;
  /** Space to reserve at the bottom for art, in `vw` (% of viewport width). */
  bottom: number;
}>;

export const artSafeZones: Readonly<Record<string, ArtSafeZone>> = {
  rustic_chic: { top: 12, bottom: 12 },
};
